import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Popover, Input, message, notification, Button} from 'antd'
import SplitNote from "../../../../shared/SplitNote"
import {updateNoteOrder, deleteNoteOrder} from "../../../../../services/api/3dApi"
import LazyLoad from 'react-lazyload'

class ItemNote extends Component {
    state = {
        visible: false,
        note: this.props.note,
    }

    _tempNote = this.props.note

    _hidePopover = () => {
        this.setState({
            visible: false,
        })
    }

    _handleVisibleChange = visible => {
        this.setState({
            visible,
        })
    }

    _handleChangeInput = e => {
        const {value} = e.target

        this._tempNote = value
    }

    _rqAddNote = async () => {
        try {
            const {orderId} = this.props
            const payload = {
                content: this._tempNote,
            }

            const {data: response} = await updateNoteOrder(orderId, payload)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                note: this._tempNote,
            })

            message.success('Đã thêm note')
        } catch (e) {
            notification.error({
                message: 'ERROR',
                description: e.message,
                duration: 0,
            })
        } finally {
            this._hidePopover()
        }
    }

    _rqDeleteNote = async () => {
        try {
            const {orderId} = this.props

            const {data: response} = await deleteNoteOrder(orderId)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                note: '',
            })

            this._tempNote = ''

            message.success('Đã xóa note')
        } catch (e) {
            notification.error({
                message: 'ERROR',
                description: e.message,
                duration: 0,
            })
        } finally {
            this._hidePopover()
        }
    }

    render() {
        const {visible, note} = this.state

        const content = (
            <div>
                {
                    visible && <Input.TextArea defaultValue={note} autoSize={{minRows: 3, maxRows: 5}}
                                               onChange={this._handleChangeInput}/>
                }

                <div className='d-flex justify-content-end mt-1'>
                    <Button type='link' size='small' onClick={this._rqDeleteNote} className='text-danger'>Xóa</Button>
                    <Button type='link' size='small' onClick={this._rqAddNote}>Lưu</Button>
                </div>
            </div>
        )

        return (
            <td className='ItemNote'>
                <LazyLoad>
                    
                    <div className='Content d-inline-block'>
                        <SplitNote note={note} number={7}/>
                    </div>

                    <Popover visible={visible} onVisibleChange={this._handleVisibleChange} title='Note' content={content}
                            placement='bottom'
                            trigger='click'>
                        <Button type='link' icon='edit'/>
                    </Popover>
                </LazyLoad>
            </td>
        )
    }
}

ItemNote.defaultProps = {
    note: '',
}

ItemNote.propTypes = {
    note: PropTypes.string,
}

export default ItemNote
